import axios from 'axios';
import { API_RESULT_CD, BAD_REQUEST, CommonResult, createApiRequestUrl, FORBIDDEN, INTERNAL_SERVER_ERROR, NOT_FOUND, OK } from '../Common';
import { API_EXCEPTION_MSG } from '../../Common';

export interface MasterAnnotationProps {
  annotationId: number;
  annotationText: string;
  linkText?: string;
  linkUrl?: string;
}

export interface MasterDetailApiGetAllAnnotationResponse {
  annotationMstList: Array<MasterAnnotationProps>;
  result?: CommonResult;
}

export const masterDetailApiGetAllAnnotation = async (): Promise<MasterDetailApiGetAllAnnotationResponse> => {
  try {
    const URL = createApiRequestUrl('master/annotation');
    const { data, status } = await axios.get<MasterDetailApiGetAllAnnotationResponse>(URL);
    switch (status) {
      case OK.status:
        return {
          annotationMstList: data.annotationMstList,
        };
      case INTERNAL_SERVER_ERROR.status:
        throw new Error(INTERNAL_SERVER_ERROR.message);
      case BAD_REQUEST.status:
        throw new Error(BAD_REQUEST.message);
      case NOT_FOUND.status:
        throw new Error(NOT_FOUND.message);
      case FORBIDDEN.status:
        throw new Error(FORBIDDEN.message);
      default:
        throw new Error('APIとの接続に失敗しました');
    }
  } catch (error) {
    return {
      annotationMstList: [],
      result: {
        jobDateTime: '',
        resultCd: API_RESULT_CD.ERROR,
        resultMessageDtoList: [
          {
            resultMessageCd: '9999',
            resultMessage: `${API_EXCEPTION_MSG}  エラー内容:[${error}]`,
          },
        ],
      },
    };
  }
};
